module.exports = __webpack_public_path__ + "static/damera-gardens-rera_page-0001-5a685de976c88f9b9f163c65d99a1984.jpg";